import React from 'react';
import { InputFile, InputFileProps } from './input-file/input-file';
import { InputNumber, InputNumberProps } from './input-number';
import { InputText, InputTextProps } from './input-text';

interface InputType {
  Text: React.FC<InputTextProps>;
  Number: React.FC<InputNumberProps>;
  File: React.FC<InputFileProps>;
}

export const Input: React.FC & InputType = () => <></>;

Input.Text = InputText;
Input.Number = InputNumber;
Input.File = InputFile;
